<template>
  <!-- loading -->
  <transition>
    <div id="loading" v-show="isLoading">
    <!-- <div id="loading"> -->
      <div class="count in-train">
        <!--        <div class="range-slider">-->
        <!--          <div class="range" :style="{width:loadingRate + '%'}"></div>-->
        <!--        </div>-->
        <!--        <p class="range-per" :style="{'padding-left':loadingRate + '%'}">{{loadingRate}}%</p>-->
      </div>

      <div id="loading-cnt">
        <!--        <div class="cover" :style="{width:loadingRate + '%'}"></div>-->
        <div class="cover" style="width: 0"></div>
      </div>
      <!--      <div id="loading-word" class="word"><img src="./assets/image/word.png"></div>-->
      <div class="module-content">
        <loading :rate="(loadingRate / 100)" bg-ring-color="#ccc" ring-color="#3a4649" :stroke-width="40"
          stroke-linecap="butt" :part="8" :part-gap="12">
          <span>
            <span>{{ `${(loadingRate).toFixed(0)}%` }}</span>
          </span>
        </loading>
      </div>
    </div>
  </transition>
  <div id="sd" ref="sd"></div>
  <!-- UI -->
  <div class="special-text" v-show="!isHideMenu && currentView !== 'in'">
    产品模型为瑞虎5x高能版 1.5T-CVT豪华型，仅供参考，具体以实际为准
  </div>
  <div class="special-text" v-show="!isHideMenu && currentView == 'in'">
    产品模型为瑞虎5x高能版 1.5T-CVT豪华型，仅供参考，具体以实际为准
  </div>
  <audio id="bgMusic" src="../public/imgs/bgm.mp3" preload="auto" ref="audio" loop></audio>
  <audio id="qidongSound" ref="audio2" src="../public/imgs/qidong.mp3"></audio>
  <audio id="xingshiSound" ref="audio3" src="../public/imgs/xingshi.mp3"></audio>
  <div class="light-point-bg" v-show="showLightPoint" @click="closeLightPoint()"></div>
  <div class="light-point" v-if="showLightPoint">
    <div class="light-point-tab" v-show="showLightTab">
      <div class="tab-item fix" :class="{ active: currentTab === 1 }" @click="changeLightTab(1)">潮酷颜值</div>
      <div class="tab-item fix" :class="{ active: currentTab === 2 }" @click="changeLightTab(2)">潮趣驾控</div>
      <div class="tab-item fix" :class="{ active: currentTab === 3 }" @click="changeLightTab(3)">潮感智能</div>
    </div>
    <div class="light-point-close-btn" v-if="showLightPoint" @click="closeLightPoint()">×</div>
    <swiper :touchRatio="0.1" :navigation="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }"
      :pagination="{ clickable: true }" autoplay grabCursor ref="hits">
      <swiper-slide v-for="(item, index) in nowLightPoint" :key="index">
        <div class="item-box">
          <div class="pic-box" v-if="item.type === 'image'">
            <img :src="item.image" alt="">
          </div>
          <div class="video-box" v-if="item.type === 'video'">
            <video :src="'./' + item.video" :id="item.video" controls loop airplay="allow" x-webkit-airplay="true"
              x5-video-player-fullscreen="true" x5-playsinline playsinline webkit-playsinline
              :poster="'./' + item.image"></video>
          </div>
          <div class="text-box" v-show="item.title != ''">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
            <div class="text">{{ item.text2 }}</div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev" v-show="nowLightPoint.length > 1"></div>
      <div class="swiper-button-next" v-show="nowLightPoint.length > 1"></div>
    </swiper>

  </div>
  <!-- 侧边按钮 -->
  <div class="top-btn" v-show="!isHideMenu" v-if="isShowRightMenu">
    <div class="item sp" @click="jump('https://www.chery.cn/m/buysupport/testdrive/?car_models=tiggo5xgaoneng')" v-show="!showSalesBox">
      <div class="pic first"><img src="../public/imgs/icon2/yuyueshijia.png"></div>
      <div class="text" :class="{ white: isNight }">预约品鉴</div>
    </div>
    <div class="item" @click="jump('https://www.chery.cn/buysupport/dealerlist/?car_models=tiggo5xgaoneng')" v-show="!showSalesBox">
      <div class="pic"><img src="../public/imgs/icon2/jingxiaoshang.png"></div>
      <div class="text" :class="{ white: isNight }">经销商查询</div>
    </div>
    <div style="margin-top: -24px">
      <img src="../public/imgs/icon2/xian.png">
    </div>
    <div v-show="rightMenuShowMore">
      <div class="item" @click="jump('https://www.chery.cn/m/vehicles/tiggo5xgaoneng/carconfig/')" v-show="!showSalesBox">
        <div class="pic"><img src="../public/imgs/icon2/peizhi.png"></div>
        <div class="text" :class="{ white: isNight }">配置表</div>
      </div>
      <div class="item" @click="jump('https://www.chery.cn/buysupport/comparison/?car_models=tiggo5xgaoneng')"
        v-show="!showSalesBox">
        <div class="pic"><img src="../public/imgs/icon2/duibi.png"></div>
        <div class="text" :class="{ white: isNight }">车型对比</div>
      </div>
      <div class="item" @click="jump('https://www.chery.cn/buysupport/finance?car_models=tiggo5xgaoneng')"
        v-show="!showSalesBox">
        <div class="pic"><img src="../public/imgs/icon2/jinrong.png"></div>
        <div class="text" :class="{ white: isNight }">金融服务</div>
      </div>
      <!--      <div class="item" @click="share" v-show="!showSalesBox">-->
      <!--        <div class="pic"><img src="../public/imgs/icon2/yinyueguan.png"></div>-->
      <!--        <div class="text" :class="{ white :isNight}">音乐关</div>-->
      <!--      </div>-->
      <div class="item" @click="rightMenuShowMore = false" v-show="!showSalesBox">
        <div class="pic last"><img src="../public/imgs/icon2/guanbi.png"></div>
      </div>
    </div>
    <div class="item" @click="rightMenuShowMore = true" v-show="!rightMenuShowMore">
      <div class="pic"><img src="../public/imgs/icon2/gengduo.png"></div>
      <div class="text" :class="{ white: isNight }">更多</div>
    </div>
  </div>
  <div class="left-btn" v-show="!isHideMenu">
    <div class="item" @click="toSport" v-show="!showSalesBox && currentView !== 'in'">
      <div class="pic"><img src="../public/imgs/icon2/qidong.png"></div>
      <div class="text" :class="{ white: isNight }">一键{{ isSport ? '停止' : '启动' }}</div>
    </div>
    <div class="item" @click="changeLightTab(1)" v-show="!showSalesBox && currentView !== 'in'">
      <div class="pic"><img src="../public/imgs/icon2/liangdian.png"></div>
      <div class="text" :class="{ white: isNight }">车型亮点</div>
    </div>
    <div class="item" @click="changeLightTab(2)" v-show="!showSalesBox && currentView === 'in'">
      <div class="pic"><img src="../public/imgs/icon2/liangdian.png"></div>
      <div class="text" :class="{ white: isNight }">车型亮点</div>
    </div>
    <div class="item" @click="playMusic()" v-show="!showSalesBox">
      <div class="pic" v-show="!isPlayMusic"><img src="../public/imgs/icon2/yinyueguan.png"></div>
      <div class="pic" v-show="isPlayMusic"><img src="../public/imgs/icon2/yinyuekai.png"></div>
      <div class="text" :class="{ white: isNight }">音乐{{ !isPlayMusic ? '关' : '开' }}</div>
    </div>
  </div>
  <!--  <div class="drive-btn" v-show="!isHideMenu" @click="jump('https://www.chery.cn/buysupport/testdrive/?car_models=tiggo9')">-->
  <!--    <img src="./assets/image/drive.png" />-->
  <!--  </div>-->
  <!-- 顶部按钮 -->
  <div class="top-panel" :class="{ 'hide': isHideMenu }">
    <div class="tab-box">
      <div class="tab-item" :class="{ active: currentView === 'out' || currentView === 'hub' }"
        @click="changeView('out')">外观</div>
      <div class="tab-item" :class="{ active: currentView === 'in' }" @click="changeView('in')">内饰</div>
    </div>
  </div>
  <div class="top-panel-line" :class="{ 'hide': isHideMenu }" v-if="false">
    <div @click="showConfigLine = !showConfigLine">
      {{ currentBaseLine.name }}
      <div class="arrow" v-show="showConfigLine">▲</div>
      <div class="arrow" v-show="!showConfigLine">▼</div>
    </div>
    <div class="line-list" v-show="showConfigLine">
      <div class="item" v-for="(item, index) in configLineList" :key="index" @click="changeConfigLine(item)">
        {{ item.name }}
      </div>
    </div>
  </div>
  <!-- 底部 -->
  <div class="bottom-panel" :class="{ 'hide': isHideMenu }">
    <div class="hide-button" v-show="!isHideMenu" @click="hideMenu()"></div>
    <div class="show-button" v-show="isHideMenu" @click="showMenu()"></div>

    <div class="content-box" v-show="currentView === 'out'">
      <div class="item-box" :style="{ 'width': getItemWidth(exColors) }">
        <div v-for="(item, index) in getTrueList(exColors)" v-show="item.show" class="color-item"
          :style="{ 'margin-top': getItemTop(getTrueList(exColors).length, index) }"
          :class="currentExColor === item.color ? 'active' : ''" @click="changeExColor(item.color)" :key="item.name">
          <div class="color-img" :style="{ background: item.bgkColor }"></div>
          <div class="color-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="content-box hub-style" v-show="currentView === 'hub'">
      <div class="item-box">
        <div v-for="item in hubList" v-show="item.show" class="color-item"
          :class="currentHub === item.code ? 'active' : ''" @click="changeHub(item)" :key="item.name">
          <div class="color-img"><img :src="item.icon"></div>
          <div class="color-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="content-box inner-style" v-show="currentView === 'in'">
      <div class="item-box" :class="{ 'only-one': getShowItemNumber(chairList) === 1 }">
        <div v-for="(item, index) in getTrueList(chairList)" v-show="item.show" class="color-item"
          :class="currentInColor === item.color ? 'active' : ''"
          :style="{ 'margin-top': getItemTop(getTrueList(chairList), index) }" @click="changeChair(item)"
          :key="item.name">
          <div class="color-img" :style="{ background: item.bgkColor }"></div>
          <div class="color-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div class="tab-box" v-show="currentView === 'out' || currentView === 'hub'">
      <div class="tab-item" :class="{ active: currentView === 'out' }" @click="changeView('out')">车漆</div>
      <div class="tab-item" :class="{ active: currentView === 'hub' }" @click="changeView('hub')">轮毂</div>
    </div>
    <div class="tab-box" v-show="currentView === 'in'">
      <div class="tab-item" :class="{ active: switchText === 1 }" @click="frontAndBackBtn(1)">前排</div>
      <div class="tab-item" :class="{ active: switchText === 2 }" @click="frontAndBackBtn(2)">后排</div>
    </div>
  </div>

</template>

<script>
import { getKrpano, getQueryString, isLandspace, getBrowser, versionCompare, diffPos, BGMAutoPlayMgr } from './utils'
import { Base64 } from 'js-base64';
import { Tween, update } from '@tweenjs/tween.js'
import lightPoint from '../public/lightPoint'
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/swiper.scss'
import 'swiper/components/scrollbar/scrollbar.scss'
import 'swiper/components/pagination/pagination.scss'
import 'swiper/swiper-bundle.css'
import { throttle } from '@/utils';
import Loading from '@/com/loading.vue'

import carInfo from "./car/id3"
const dev = ""
const ossUrl = dev ? '' : '' // url 配置
const carCode = 'id3' // 车辆代码

const glassList = [
  "Scene_cheshen_glass",
  "Scene_Dummy001_lf_door_glass",
  "Scene_Dummy003_rf_door_glass",
  "Scene_Dummy002_lr_door_glass",
  "Scene_Dummy004_rr_door_glass",
  "Scene_Dummy005_trunk_glass",
  "Scene_34_car_size_map_g"
]
const hotList = [
  'light_point_1',
  'light_point_2',
  'light_point_3',
  'light_point_4',
  'light_point_5',
]
const hotInnerList = [
  'hotspot_sale1',
  'hotspot_sale2',
  'hotspot_sale3',
  'hotspot_sale4'
]
const actionHotList = [
  'lf_door',
  'lr_door',
  'rf_door',
  'rr_door',
  'trunk'
]
const actionHotRelationship = {
  'lf_door': {
    tip: '00_lf_door_tip',
    action: 'btnrExhOvalDoorSwhFLCk',
    name: '左前门开关'
  },
  'lr_door': {
    tip: '00_lr_door_tip',
    action: 'btnrExhOvalDoorSwhBLCk',
    name: '左后门开关'
  },
  'rf_door': {
    tip: '00_rf_door_tip',
    action: 'btnrExhOvalDoorSwhFRCk',
    name: '右前门开关'
  },
  'rr_door': {
    tip: '00_rr_door_tip',
    action: 'btnrExhOvalDoorSwhBRCk',
    name: '右后门开关'
  },
  'trunk': {
    tip: '00_trunk_tip',
    action: 'btnrExhOvalTrnkSwhCk',
    name: '后备箱门开关'
  }
}
const env = getQueryString('env')
const isInterior = getQueryString('isInterior')
const isPreview = getQueryString('isPreview') //是否是预加载

const appVersion = getQueryString('appVersion') || ''
const userId = getQueryString('userId') || ''
const application = getQueryString('application') || 'Web'
const seriesId = getQueryString('seriesId') || ''
const deviceModel = getQueryString('deviceModel') || ''
const longitude = getQueryString('longitude') || ''
const latitude = getQueryString('latitude') || ''
const IMEI = getQueryString('IMEI') || ''
const ip = getQueryString('ip') || ''
const tencentOpenId = getQueryString('tencentOpenId') || ''
const sourceId = getQueryString('sourceId') || ''
const tencentUnionId = getQueryString('tencentUnionId') || ''
const inviteeId = getQueryString('inviteeId') || ''
const inviteeVisitId = getQueryString('inviteeVisitId') || ''
const inviteeOpenId = getQueryString('inviteeOpenId') || ''

// console.log('env', env);

let startTime = Date.now()
let stayTime = Date.now()

const PATH_TO_INTER = [
  new newFontre.THREE.Vector3(63, 140, 591), // 起点
  new newFontre.THREE.Vector3(221, 140, 636),
  new newFontre.THREE.Vector3(269, 140, 405),
  new newFontre.THREE.Vector3(21, 140, 214) // 终点
]

const TARGET_START = new newFontre.THREE.Vector3(0, 100, 0)
const TARGET_TO = new newFontre.THREE.Vector3(-41, 100, 36)
const TARGET_HUB = new newFontre.THREE.Vector3(-130, 30, 100)

const PATH_TO_HUB = [
  new newFontre.THREE.Vector3(-263, 140, 1091), // 起点
  new newFontre.THREE.Vector3(221, 140, 636),
  new newFontre.THREE.Vector3(269, 140, 605),
  new newFontre.THREE.Vector3(-160, 30, 400) // 终点
]

const PATH_TO_HUB_m = [
  new newFontre.THREE.Vector3(-1274, 256, 1849), // 起点
  new newFontre.THREE.Vector3(221, 140, 636),
  new newFontre.THREE.Vector3(269, 140, 605),
  new newFontre.THREE.Vector3(-160, 30, 400) // 终点
]

const PATH_TO_CAR = [
  new newFontre.THREE.Vector3(-1074, 173, 471), // 起点
  new newFontre.THREE.Vector3(-1374, 162, 23),
  new newFontre.THREE.Vector3(-1574, 155, -605),
  new newFontre.THREE.Vector3(-1836, 150, -1049) // 终点
]
let nowPosArr = ''
let lastXY = ''
let lastPos = {}
let isFirst = true
let touchTimeout = setTimeout(() => { })
let timer

SwiperCore.use([Pagination, Navigation, Autoplay])

export default {
  name: 'App',
  components: {
    Swiper,
    SwiperSlide,
    Loading
  },
  data() {
    return {
      isPlayMusic: false,
      currentTab: 1,
      showConfigLine: false,
      rightMenuShowMore: false,
      loadingRate: 32,
      loadingCondition1: false,
      loadingCondition2: false,
      showIframe: false,
      iframeUrl: '',
      showSalesBox: false,
      showShareBox: false,
      application: 'Web',
      switchText: 1,
      isHideMenu: false,
      showPopup: false,
      clientMode: false,
      devMode: false,
      HideDevPanel: false,
      isInitGL: false,
      showInnerButton: true,
      connectTypeTxt: '带看中',
      isLoading: true,
      currentView: 'out',
      platform: 'app',
      currentExColor: '',
      currentHub: 'lungu1',
      currentInColor: 'hei',
      showCloseBtn: false,
      currentInPositon: 'hei',
      currentScene: 'scene_highway',
      currentInnerView: '',
      currentInnerBase: 'blue',
      currentBaseLine: '',
      lastView: '',
      fullScreenStatus: 'close',
      nowConfigLine: '',
      isOpenLight: false,
      isNight: false,
      lock: false,
      isSport: false,
      isShowRightMenu: true,
      // 内饰选装包池子
      innerPackPool: {
        chair: 'hei',
        showHotspot: 0,
        color: 'red'
      },
      // 外饰颜色
      exColors: [
        {
          name: '钻石银',
          color: 'sliver',
          show: true,
          icon: './imgs/icon/sliver_black.png',
          action: 'btnrExhOvalCloPplCk',
          bgkColor: '#bdc1cb'
        },
        {
          name: '珍珠白',
          color: 'white',
          show: true,
          icon: './imgs/icon/blue.png',
          action: 'btnrExhOvalCloBluCk',
          bgkColor: '#ffffff'
        },
        {
          name: '量子灰',
          color: 'gray',
          show: true,
          icon: './imgs/icon/white.png',
          action: 'btnrExhOvalCloPnkCk',
          bgkColor: '#3a3c3d'
        },
      ],
      // 内饰视角
      inView: [
        {
          name: '前排视角',
          code: '',
        },
        {
          name: '后排视角',
          code: '_back',
        },
      ],
      // 右上角按钮
      fullscreenData: [
        {
          name: '查看全屏',
          code: 'open',
          position: [-1166, 116, 678],
        },
        {
          name: '退出全屏',
          code: 'close',
          position: [-514, 91, 301],
        },
      ],
      // 其他配置
      packageList: [

      ],
      // 基础配置线
      configLineList: [
        {
          name: '5X高能版 1.5T豪华型',
          codes: ['neishi_black','dingpei'],
          baseLine: 'line1',
          hub: 'lungu1'
        },
        // {
        //   name: '瑞虎9 2.0T-8AT 至臻版',
        //   codes: ['seat_7zuo', 'neishi_black', 'lungu1', 'siqu'],
        //   baseLine: 'line1',
        //   hub: 'lungu1'
        // },
        // {
        //   name: '瑞虎9 2.0T-8AT 超舒适·尊享版',
        //   codes: ['seat_7zuo', 'neishi_brown', 'lungu1', 'fei_siqu'],
        //   baseLine: 'line2',
        //   hub: 'lungu1'
        // },
        // {
        //   name: '瑞虎9 2.0T-8AT 豪华版',
        //   codes: ['seat_7zuo', 'neishi_black', 'lungu1', 'fei_siqu'],
        //   baseLine: 'line1',
        //   hub: 'lungu1'
        // },
        // {
        //   name: '瑞虎9 2.0T-7DCT 超舒适·尊尚版',
        //   codes: ['seat_5zuo', 'neishi_brown', 'lungu1', 'fei_siqu'],
        //   baseLine: 'line2',
        //   hub: 'lungu1'
        // },
        // {
        //   name: '瑞虎9 2.0T-7DCT 豪华版',
        //   codes: ['seat_5zuo', 'neishi_black', 'lungu1', 'fei_siqu'],
        //   baseLine: 'line1',
        //   hub: 'lungu1'
        // },
        // {
        //   name: '瑞虎9 2.0T-7DCT 领先版',
        //   codes: ['seat_5zuo', 'neishi_black', 'lungu2', 'fei_siqu'],
        //   baseLine: 'line3',
        //   hub: 'lungu2'
        // }
      ],
      //  场景
      sceneList: [
        {
          name: '纯色',
          code: 'scene_highway',
          hdr: 0
        },
        {
          name: '实景',
          code: 'scene_white',
          hdr: 1
        }
      ],
      // hdr
      envList: [
        {
          name: '纯色',
          code: 'env'
        },
        {
          name: '实景',
          code: 'white'
        }
      ],
      // 轮毂
      hubList: [
        // {
        //   name: '20吋轮毂',
        //   code: 'lungu1',
        //   show: false,
        //   icon: './imgs/icon/hub1.png',
        // },
        {
          name: '17吋轮毂',
          code: 'lungu1',
          show: true,
          icon: './imgs/icon/hub1.png',
        },
        // {
        //   name: '凌动黯黑轮辋',
        //   code: 'lungu2',
        //   show: true,
        //   icon: './imgs/icon/hub2.png',
        // }
      ],
      // 座椅
      chairList: [
        {
          name: '黑色',
          color: 'hei',
          show: true,
          icon: './imgs/icon/blue2.png',
          otherCode: ['neishi_black'],
          action: 'btnrExhOvalInteriorBlackCk',
          bgkColor: `#000000`
        },
      ],
      // 饰条
      trimList: [

      ],
      // 内饰顶棚
      roofList: [

      ],
      // 交互热点
      hotSpotList: [
        {
          name: '显示交互热点',
          code: 'showActionHotSpot'
        },
        {
          name: '隐藏交互热点',
          code: 'HideActionHotSpot'
        },
        // {
        //   name: '显示卖点热点',
        //   code: 'showSalesHotSpot'
        // },
        // {
        //   name: '隐藏卖点热点',
        //   code: 'HideSalesHotSpot'
        // },
      ],
      showLightPoint: false,
      showLightTab: false,
      nowLightPoint: [{}],
    }
  },

  mounted() {
    this.$refs.audio.src = require("../public/imgs/bgm.mp3");
    this.$refs.audio2.src = require("../public/imgs/qidong.mp3");
    this.$refs.audio3.src = require("../public/imgs/xingshi.mp3");
    // const bgm = new BGMAutoPlayMgr('../public/imgs/bgm.mp3');
    //
    // bgm.toggleBGM();

    // 自动播放音乐效果，解决微信自动播放问题
    document.addEventListener('touchstart', this.audioAutoPlay, false);
    document.addEventListener('mousedown', this.audioAutoPlay, false);
    // if(application !== 'Android'){
    //     document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    // }

    let oAudio = document.querySelector("#bgMusic");
    oAudio.onended = function () {//播放完毕，重新循环播放
      oAudio.load();
      oAudio.play();
    }
    this.application = application
    this.gio('pgerExhOvalOnVie', false)
    // console.log(123123,lightPoint)
    // const that = this
    // this.initLoading()
    // this.initGL()
    // console.log(getQueryString('env'))
    timer = setInterval(() => {
      if (this.loadingRate < 100) {
        this.loadingRate++
      }
    }, 80)
    this.listenEvent()
    //打开页面直接进入3D模式
    this.$nextTick(() => {
      this._toggleFullscreenCallback(this.fullscreenData[0])
      newFontre.camera.far = 37000
      newFontre.scene.fog = new newFontre.THREE.Fog('#757b87', 6000, 6001)
    })

    this.devMode = 1 //getQueryString('hidepanel')
    this.clientMode = getQueryString('user') === 'client'
    this.isShowRightMenu = getQueryString('switch') !== 'off'  //是否显示外链

  },

  methods: {
    playMusic() {
      let oAudio = document.querySelector("#bgMusic");
      if (!this.isPlayMusic) {
        oAudio.play();//让音频文件开始播放
      } else {
        oAudio.pause();//让音频文件暂停播放
      }
      this.isPlayMusic = !this.isPlayMusic;
    },
    audioAutoPlay() {
      let audio = document.getElementById('bgMusic');
      this.isPlayMusic = true;
      audio.play();
      document.removeEventListener('touchstart', this.audioAutoPlay);
      document.removeEventListener('mousedown', this.audioAutoPlay);
    },

    changeLightTab(val) {
      if (val === 4 && this.isPlayMusic) {
        this.playMusic()
      }
      this.showLightPoint = false
      setTimeout(() => {
        this.currentTab = val
        this.nowLightPoint = lightPoint['tab' + val]
        this.showLightPoint = true
        this.showLightTab = true
      }, 3)
    },
    jump(val) {
      window.open(val)
    },
    getItemWidth(father, val) {
      let long = 0
      for (const item of father) {
        if (item.show) {
          long++
        }
      }
      const top = long * 13
      return top + '%'
    },
    getShowItemNumber(father) {
      let long = 0
      for (const item of father) {
        if (item.show) {
          long++
        }
      }
      return long
    },
    getTrueList(array) {
      let _array = []
      for (const item of array) {
        if (item.show) {
          _array.push(item)
        }
      }
      return _array
    },
    getItemTop(father, val) {
      let top = Math.abs(val + 1 - (father + 1) / 2) * 16 + (10 / father) * 3
      //正中间
      if (((val + 1)) === (father + 1) / 2) {
        top = top + 8
      }
      return top + 'px'
    },
    isMobile() {
      return (application === 'Minp' || application === 'Android' || application === 'iOS')
    },
    isOldVersion() {
      if (application === 'Minp') {
        return false
      } else {
        return (versionCompare('3.5.0', appVersion) >= 0)
      }
    },
    // 切换白天夜晚
    changeNight() {
      if (this.isNight) {
        // 切换白天
        this.isNight = !this.isNight
        this.changeInColor(this.currentInnerView)
        this.gio('btnrExhOvalDayNightSwhCk', '日间模式')
      } else {
        // 切换夜晚
        this.isNight = !this.isNight
        this.changeInColor(this.currentInnerView)
        this.gio('btnrExhOvalDayNightSwhCk', '夜间模式')
      }
    },
    // 切换前后排
    frontAndBackBtn(val) {
      if (val === this.switchText) {
        return
      }
      if (this.switchText == 1) {
        // 切换到后排
        this.switchText = 2;
        this.currentInnerView = '_back'
        this.changeInColor('_back')
        this.gio('btnrExhOvalBackSwhCk', '后排切换')
      } else {
        // 切换到前排
        this.switchText = 1;
        this.currentInnerView = ''
        this.changeInColor('')
        this.gio('btnrExhOvalFrontSwhCk', '前排切换')
      }
    },
    // 隐藏菜单
    async hideMenu() {
      this.isHideMenu = true
      this.changeModel("HideActionHotSpot")
      // if (!this.krpano){
      //   this.krpano = await getKrpano()
      // }
      // if (hotInnerList.length > 0) {
      //   for (const item of hotInnerList) {
      //     this.krpano.call(`set_hotspot_hide(${item})`);
      //   }
      // }
    },
    // 显示菜单
    async showMenu() {
      this.isHideMenu = false
      if (!this.isSport) {
        this.changeModel("showActionHotSpot")
      }
      if (!this.krpano) {
        this.krpano = await getKrpano()
      }
      // if (hotInnerList.length > 0) {
      //   for (const item of hotInnerList) {
      //     this.krpano.call(`set_hotspot_display(${item})`);
      //   }
      // }
    },
    //切换内外饰
    async changeView(value, skipAni) {

      if (this.currentView === value) return

      if (this.lock) return
      this.lock = true

      if (value === 'out') {
        this.gio('btnrExhOvalPntSlcCk', '车漆选择')
        newFontre.showExterior(carCode).then(() => {
          for (const item of this.chairList) {
            if (this.currentInColor === item.color) {
              for (const val of item.otherCode) {
                newFontre.updateModel(val)
              }
            }
          }
        })
        if (!skipAni && (this.currentView === 'hub' || this.lastView === 'hub')) {
          if (!this.isSport) {
            this.changeModel("changkuangao_chicun_open")
            await this._leaveHubAnimation()
            setTimeout(() => {
              this.changeModel("showActionHotSpot")
            }, 500)
          }

        }
      }
      if (value === 'hub') {
        this.gio('btnrExhOvalHubSlcCk', '轮毂选择')
        newFontre.showExterior(carCode).then(() => {
          for (const item of this.chairList) {
            if (this.currentInColor === item.color) {
              for (const val of item.otherCode) {
                newFontre.updateModel(val)
              }
            }
          }
        })
        if (!skipAni && this.currentView === 'out') {
          this.changeModel("changkuangao_chicun_off")
          if (!this.isSport) {
            await this._nextHubAnimation()
          }
          this.changeModel("HideActionHotSpot")
        }
      }
      if (value === 'in') {
        // if(!skipAni){
        //   await this._toInterAnimation()
        // }
        this.gio('btnrExhOvalTrmSlcCk', '查看内饰')
        if (isFirst) {
          this.gio('btnrExhOvalFrontSwhCk', this.switchText === 1 ? '前排切换' : '后排切换')
          this.gio('btnrExhOvalDayNightSwhCk', this.isNight ? '夜间模式' : '日间模式')
          isFirst = false
        }
        await newFontre.showInterior(carCode)
        await this.changeInColor(this.currentInnerView)
      }

      this.lastView = this.currentView
      this.currentView = value
      this.lock = false


    },
    // 进入内饰的动画
    _toInterAnimation() {
      newFontre.orbit.enabled = false
      newFontre.orbit.minDistance = 0
      newFontre.orbit.target.set(0, 60, 0)
      // if (!newFontre.clickEvent._state['00_lf_door_tip']) {
      //   newFontre.clickEvent.clickDoor('00_lf_door_tip')
      // }

      newFontre.orbit.minDistance = 0

      const curve = new newFontre.THREE.CubicBezierCurve3(
        ...PATH_TO_INTER
      )
      const points = curve.getPoints(100)
      const tween1 = new Tween(points[0]).to(points[100], 3000).start()
      new Tween(newFontre.orbit.target).to(TARGET_TO, 3000).start()

      tween1.onUpdate(e => {
        newFontre.camera.position.copy(e)
      })

      return new Promise(res => {
        tween1.onComplete(() => {
          this._setDistance()
          newFontre.orbit.enabled = true
          if (newFontre.clickEvent._state['00_lf_door_tip']) {
            newFontre.clickEvent.clickDoor('00_lf_door_tip')
          }
          res()
        })
      })
    },
    // 进入外观动画
    _toExterAnimation() {

      newFontre.orbit.enabled = false
      newFontre.orbit.minDistance = 0

      // if (newFontre.clickEvent._state['00_lf_door_tip']) {
      //   newFontre.clickEvent.clickDoor('00_lf_door_tip')
      // }

      const curve = new newFontre.THREE.CubicBezierCurve3(
        ...[...PATH_TO_HUB].reverse()
      )
      const points = curve.getPoints(100)
      const tween1 = new Tween(points[0]).to(points[100], 100).start()
      new Tween(newFontre.orbit.target).to(TARGET_START, 100).start()

      tween1.onUpdate(e => {
        const { x, y, z } = e
        newFontre.camera.position.set(x, y, z)
      })

      return new Promise(res => {
        tween1.onComplete(() => {
          this._setDistance()
          newFontre.orbit.enabled = true
          res()
        })
      })
    },
    // 靠近轮毂动画
    _nextHubAnimation() {
      newFontre.orbit.enabled = false
      newFontre.orbit.minDistance = 0
      const curve = new newFontre.THREE.CubicBezierCurve3(
        ...[...PATH_TO_HUB]
      )
      const points = curve.getPoints(100)
      const tween1 = new Tween(newFontre.camera.position).to(points[100], 1000).start()
      new Tween(newFontre.orbit.target).to(TARGET_HUB, 1000).start()
      this.stopAutoRotate()
      tween1.onUpdate(e => {
        const { x, y, z } = e
        newFontre.camera.position.set(x, y, z)
      })

      return new Promise(res => {
        tween1.onComplete(() => {
          newFontre.orbit.maxDistance = 300
          newFontre.orbit.minDistance = 300
          newFontre.orbit.maxAzimuthAngle = 0.4
          newFontre.orbit.minAzimuthAngle = -0.4
          newFontre.orbit.enabled = true
          newFontre.orbit.maxPolarAngle = 1.6
          newFontre.orbit.minPolarAngle = 1
          // const obj = {
          //   type : "animation",
          //   value : 'end',
          //   name: '_nextHubAnimation',
          //   platform : this.platform
          // }
          // window.parent.postMessage(obj,'*')
          res()
        })
      })
    },
    // 远离轮毂动画
    _leaveHubAnimation() {
      newFontre.orbit.enabled = false
      newFontre.orbit.minDistance = 0
      newFontre.orbit.maxDistance = 3000
      newFontre.orbit.maxAzimuthAngle = Infinity
      newFontre.orbit.minAzimuthAngle = -Infinity
      newFontre.orbit.maxPolarAngle = 1.6
      newFontre.orbit.minPolarAngle = 0
      newFontre.orbit.target.set(-150, 30, 0)
      const _path = isLandspace() ? PATH_TO_HUB_m : PATH_TO_HUB
      const curve = new newFontre.THREE.CubicBezierCurve3(
        ...[..._path].reverse()
      )
      const points = curve.getPoints(100)
      const tween1 = new Tween(newFontre.camera.position).to(points[100], 1000).start()
      new Tween(newFontre.orbit.target).to(TARGET_START, 1000).start()
      tween1.onUpdate(e => {
        newFontre.camera.position.copy(e)
      })
      this.startAutoRotate()
      return new Promise(res => {
        tween1.onComplete(() => {
          // newFontre.orbit.target.set(0,150,0)
          this._setDistance()
          newFontre.orbit.enabled = true
          res()
        })
      })
    },
    //开始自动旋转
    startAutoRotate(val) {
      if (this.isSport || this.currentView === 'hub') {
        return
      }
      if (val) {
        newFontre.orbit.autoRotate = true
      }
      newFontre.orbit.autoRotateSpeed = 1
      // this.isHideMenu = true
      this.changeModel("HideActionHotSpot")
    },
    // 停止自动旋转
    stopAutoRotate(val) {
      if (this.isSport || this.currentView === 'hub') {
        return
      }
      if (val) {
        newFontre.orbit.autoRotate = false
      }
      newFontre.orbit.autoRotateSpeed = 0
      // this.isHideMenu = false
      this.changeModel("showActionHotSpot")
    },
    // 设置视角距离
    _setDistance() {
      if (isLandspace()) {
        // 竖屏
        newFontre.orbit.maxDistance = 2250
        newFontre.orbit.minDistance = 750
        newFontre.orbit.maxPolarAngle = 1.50
        // 阻尼
        newFontre.orbit.enableDamping = true;
        newFontre.orbit.dampingFactor = 0.1; // 奥迪
        newFontre.orbit.customDampingNum = { theta: 0.4, phi: 0.7 }

        // 缩放阻尼
        newFontre.orbit.enableZoomDamping = true;
        newFontre.orbit.zoomDampingFactor = 0.8;

        newFontre.orbit.zoomSpeed = 0.8;

      } else {
        newFontre.orbit.maxPolarAngle = 1.53
        //  横屏
        if (getBrowser().isMobile) {
          newFontre.orbit.maxDistance = 1200
          newFontre.orbit.minDistance = 500

          // 阻尼
          newFontre.orbit.enableDamping = true;
          newFontre.orbit.dampingFactor = 0.1; // 奥迪

          // 缩放阻尼
          newFontre.orbit.enableZoomDamping = true;
          newFontre.orbit.zoomDampingFactor = 0.23;

          newFontre.orbit.zoomSpeed = 0.001;

          // this.hideMenu()
        } else {
          // 阻尼
          newFontre.orbit.enableDamping = true;
          newFontre.orbit.dampingFactor = 0.1;

          // 缩放阻尼
          newFontre.orbit.enableZoomDamping = true;
          newFontre.orbit.zoomDampingFactor = 0.23;
          newFontre.orbit.customDampingNum = { theta: 1, phi: 1.5 }

          newFontre.orbit.zoomSpeed = 0.001;
          newFontre.orbit.maxDistance = 1200
          newFontre.orbit.minDistance = 500
        }
      }
    },
    // 设置相机状态
    setPosition(value) {
      if (value === 'close') {
        // console.log('全屏')
        newFontre.orbit.maxDistance = 1000
        newFontre.orbit.minDistance = 500
      } else {
        newFontre.orbit.maxDistance = 1600
        newFontre.orbit.minDistance = 1000
      }
      // let { position } = this.fullscreenData.find((i) => i.code === value)
      // newFontre.camera.position.set(...position)
      // console.log('result', position);
    },
    // loading动画
    // initLoading() {
    //   bodymovin.loadAnimation({
    //     container: document.getElementById('loading-cnt'),
    //     renderer: 'svg',
    //     loop: true,
    //     autoplay: true,
    //     path: './js/data.json',
    //   })
    // },
    // 监听事件
    listenEvent() {
      let a = 0
      const that = this
      // // 接收iframe的message
      // window.addEventListener('message', function (e) {
      //   // console.log(e.data)  //e.data为传递过来的数据
      //   if(e.data.offStatus === "close"){
      //     that.showIframe = false
      //   }
      //   // console.log(e.origin)  //e.origin为调用 postMessage 时消息发送方窗口的 origin（域名、协议和端口）
      //   // console.log(e.source)  //e.source为对发送消息的窗口对象的引用，可以使用此来在具有不同origin的两个窗口之间建立双向通信
      // })
      window.addEventListener('resize', throttle(() => {
        // const { clientWidth, clientHeight } = document.documentElement//this.$refs.sd
        // console.log('resize', clientWidth, clientHeight)
        if (that.currentView === 'out') {
          that.resize()
        }

        a++
        if (a % 2 == 0) {
          this.fullScreenStatus = 'open'
        } else {
          this.fullScreenStatus = 'close'
        }
      }, 100, false))

      // fix iframe内饰场景导致上下滑动的bug
      document.getElementById('sd').addEventListener('touchmove', (e) => {
        e.preventDefault()
        e.stopPropagation();
      })

      document.getElementById('sd').addEventListener('mousedown', (e) => {
        this.stopAutoRotate()
        this.showConfigLine = false
        clearTimeout(touchTimeout)
      })

      document.getElementById('sd').addEventListener('mouseup', (e) => {
        touchTimeout = setTimeout(() => {
          this.startAutoRotate()
        }, 10000)
      })

      document.getElementById('sd').addEventListener('touchstart', (e) => {
        this.stopAutoRotate()
        this.showConfigLine = false
        clearTimeout(touchTimeout)
      })

      document.getElementById('sd').addEventListener('touchend', (e) => {
        touchTimeout = setTimeout(() => {
          this.startAutoRotate()
        }, 10000)
      })

      const { incolor } = this.$refs
      if (incolor) {
        incolor.addEventListener('touchmove', (e) => {
          e.preventDefault()
          e.stopPropagation();
        })
      }

    },
    // 初始化GL
    initGL() {
      const that = this
      newFontre.customEvent.on('loadModel', (num) => {
        if (num === 200) {
          this.loadingCondition1 = true
          this.loadingRate = 100
          clearInterval(timer)
          // 玻璃渲染
          for (let i = 0; i < glassList.length; i++) {
            var m = newFontre.scene.getObjectByName(glassList[i])
            if (m) {
              m.renderOrder = i + 1
            }
          }
          newFontre.camera.near = 50 // ios render bug
          // this.syncColorInfo()
          // 如果url有inter标识就默认进去内饰
          if (isInterior) {
            this.changeView('in')
          }
        }
        else if (num <= 100) {
          this.loadingRate = Math.min(this.loadingRate, 100);
          // console.log(this.loadingRate)
        }
        // else if(num > 100){
        //   this.loadingRate = 100
        //   // console.log(this.loadingRate)
        // }
      })

      newFontre.customEvent.on('render', () => {
        update()
        throttle(that.updateSizaAnimation(), 20, true)
      })

      newFontre.showExterior(carCode).then(() => {
        // console.log('initover')
        newFontre.scene.background = null
        newFontre.orbit.target.set(0, 100, 0)
        newFontre.orbit.maxPolarAngle = 1.6
        newFontre.orbit.minPolarAngle = 0

        //重置相机状态
        this.setPosition(this.fullScreenStatus)
        newFontre.camera.fov = 25
        newFontre.camera.updateProjectionMatrix()

        newFontre.insertDom(document.querySelector('#sd'))

        this.resize()
        this._setDistance()

        newFontre.customEvent.on('clickMesh', hot => {
          // console.log('you click:' + hot.name)
          if (hot.name === 'open_light') {
            this.openLight()
          }
          for (const val of hotList) {
            this.showLightTab = false
            if (hot.name === val) {
              // console.log(lightPoint,hot.name)
              this.nowLightPoint = lightPoint.outList[0][hot.name]
              this.showLightPoint = true
              this.gio('btnrExhOvalAnchorPointCk', lightPoint.outList[0][hot.name][0].title)
              this.gio('pgerExhOvalAnchorPointVie', false, '', '0', lightPoint.outList[0][hot.name][0].title)
            }
          }
          for (const val of actionHotList) {
            if (hot.name === val) {
              this.gio(actionHotRelationship[hot.name].action, actionHotRelationship[hot.name].name)
            }
          }
        })
        window.panoEmit = (name) => {
          // if(this.isHideMenu === true){
          //   return
          // }
          this.showLightTab = false
          for (const val of hotList) {
            if (name === val) {
              // console.log(lightPoint,name)
              this.nowLightPoint = lightPoint.innerList[0][name]
              this.showLightPoint = true
              this.gio('btnrExhOvalAnchorPointCk', lightPoint.innerList[0][name][0].title)
              this.gio('pgerExhOvalAnchorPointVie', false, '', '0', lightPoint.innerList[0][name][0].title)
            }
          }
        }


        this.changeConfigLine(this.configLineList[0])
        this.changeExColor(this.exColors[0].color)
        this.changeHub(this.hubList[0])
        // this.changeModel("putongcheshen")
        // this.changeModel("inner_lan")

        setTimeout(() => {
          document.getElementById('loading-cnt').style.display = 'none'
          // document.getElementById('loading-word').style.display = 'none'
          this.loadingCondition2 = true
          this.isLoading = false
          // this.changeModel("neishi_brown")
          this.changeModel("changkuangao_chicun_open")
          this.startAutoRotate(true)
          let currentTime = Date.now()
          stayTime = currentTime - startTime
          // console.log('loading time:', stayTime,'ms')
          this.gio('pgerExhOvalPageLoadDurationVie', false, stayTime)
        }, 500)
      })
      // this.resize()
    },

    updateSizaAnimation() {
      // debug
      // console.log(newFontre.orbit.getAzimuthalAngle(),123123);
      const azimuthalAngle = newFontre.orbit.getAzimuthalAngle();

      const rl9SizeTextRight = newFontre.scene.getObjectByName('size-right');
      const rl9SizeTextLeft = newFontre.scene.getObjectByName('size-left');
      const rl9SizeTextFront = newFontre.scene.getObjectByName('size-front');
      const rl9SizeTextBack = newFontre.scene.getObjectByName('size-back');

      const rl9SizeRightMain = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_c');
      const rl9SizeLeftMain = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_z');
      const rl9SizeBackMain = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_g');
      const rl9SizeFrontMain = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_k');

      // 横线
      const rl9SizeRight1 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_c_1');
      const rl9SizeRight2 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_c_2');

      const rl9SizeFront1 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_k_1');
      const rl9SizeFront2 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_k_2');

      const rl9SizeLeft1 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_z_1');
      const rl9SizeLeft2 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_z_2');

      const rl9SizeBack1 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_g_1');
      const rl9SizeBack2 = newFontre.scene.getObjectByName('Scene_RootNode_34_car_size_map_g_2');


      // 车右边尺寸动画
      if (azimuthalAngle > -1.5 && azimuthalAngle < 1.5) {
        // 执行动画显示车右边
        if (!this.isSport && this.currentView === 'out') {
          rl9SizeTextRight.visible = true
        }
        // if (rl9SizeTextRight.scale.y < 12.8) {
        //   rl9SizeTextRight.scale.y += 1;
        // }
        if (rl9SizeRightMain.scale.x < 1) {
          rl9SizeRightMain.scale.x = Math.min(rl9SizeRightMain.scale.x + 0.05, 1);
        }

        if (rl9SizeRight1.scale.y < 1) {
          rl9SizeRight1.scale.y += 0.1;
          rl9SizeRight2.scale.y += 0.1;
          // rl9SizeRight1.scale.x = 1;
          // rl9SizeRight2.scale.x = 1;
        }

      } else {
        // 执行动画隐藏车右边
        rl9SizeTextRight.visible = false
        // if (rl9SizeTextRight.scale.y >= 0) {
        //   rl9SizeTextRight.scale.y -= 1;
        // }
        if (rl9SizeRightMain.scale.x > 0) {
          rl9SizeRightMain.scale.x = Math.max(rl9SizeRightMain.scale.x - 0.05, 0);
        }
        if (rl9SizeRight1.scale.y > 0) {
          rl9SizeRight1.scale.y -= 0.1;
          rl9SizeRight2.scale.y -= 0.1;
        }
      }

      // 车后
      if (azimuthalAngle > -1.1 && azimuthalAngle < 3) {
        // 执行动画显示车后
        if (!this.isSport) {
          rl9SizeTextBack.visible = true
        }
        // if (rl9SizeTextBack.scale.y <= 12.8) {
        //   rl9SizeTextBack.scale.y += 1;
        // }
        if (rl9SizeBackMain.scale.z < 1) {
          rl9SizeBackMain.scale.z = Math.min(rl9SizeBackMain.scale.z + 0.05, 1);
        }
        // if (rl9SizeBack1.scale.x < 1) {
        //   rl9SizeBack1.scale.x += 0.1;
        //   rl9SizeBack2.scale.x += 0.1;
        // }
        if (rl9SizeBack1.scale.z < 1) {
          rl9SizeBack1.scale.z += 0.1;
          rl9SizeBack2.scale.z += 0.1;
        }
      } else {
        // 执行动画隐藏车后
        rl9SizeTextBack.visible = false
        // if (rl9SizeTextBack.scale.y >= 0) {
        //   rl9SizeTextBack.scale.y -= 1;
        // }
        if (rl9SizeBackMain.scale.z > 0) {
          rl9SizeBackMain.scale.z = Math.max(rl9SizeBackMain.scale.z - 0.05, 0);
        }
        // if (rl9SizeBack1.scale.x > 0) {
        //   rl9SizeBack1.scale.x -= 0.1;
        //   rl9SizeBack2.scale.x -= 0.1;
        // }
        if (rl9SizeBack1.scale.z > 0) {
          rl9SizeBack1.scale.z -= 0.1;
          rl9SizeBack2.scale.z -= 0.1;
        }
      }

      // 车前
      if (azimuthalAngle > -2.57 && azimuthalAngle < -0.45) {
        // 执行动画显示车前
        if (!this.isSport && this.currentView === 'out') {
          rl9SizeTextFront.visible = true
        }
        // if (rl9SizeTextFront.scale.y <= 12.8) {
        //   rl9SizeTextFront.scale.y += 1;
        // }
        if (rl9SizeFrontMain.scale.y < 1) {
          rl9SizeFrontMain.scale.y += 0.05;
        }
        if (rl9SizeFront1.scale.y < 1) {
          rl9SizeFront1.scale.y += 0.1;
          rl9SizeFront2.scale.y += 0.1;
          // rl9SizeFront1.scale.x = 1;
          // rl9SizeFront2.scale.x = 1;
        }
      } else {
        // 执行动画隐藏车前
        rl9SizeTextFront.visible = false
        // if (rl9SizeTextFront.scale.y >= 0) {
        //   rl9SizeTextFront.scale.y -= 1;
        // }
        if (rl9SizeFrontMain.scale.y > 0) {
          rl9SizeFrontMain.scale.y -= 0.05;
        }
        if (rl9SizeFront1.scale.y > 0) {
          rl9SizeFront1.scale.y -= 0.1;
          rl9SizeFront2.scale.y -= 0.1;
        }
      }

      // 车左边尺寸动画
      if (Math.abs(azimuthalAngle) > 2.0) {
        // 执行动画显示车左边
        if (!this.isSport) {
          rl9SizeTextLeft.visible = true
        }
        // if (rl9SizeTextLeft.scale.y <= 12.8) {
        //   rl9SizeTextLeft.scale.y += 1;
        // }
        if (rl9SizeLeftMain.scale.x < 1) {
          rl9SizeLeftMain.scale.x = Math.max(rl9SizeLeftMain.scale.x + 0.05, 1);
        }
        if (rl9SizeLeft1.scale.x < 1) {
          rl9SizeLeft1.scale.x += 0.1;
          rl9SizeLeft2.scale.x += 0.1;
          // rl9SizeLeft1.scale.x = 1;
          // rl9SizeLeft2.scale.x = 1;
        }
      } else {
        // 执行动画隐藏车左边
        rl9SizeTextLeft.visible = false
        // if (rl9SizeTextLeft.scale.y > 0) {
        //   rl9SizeTextLeft.scale.y -= 1;
        // }
        if (rl9SizeLeftMain.scale.x > 0) {
          rl9SizeLeftMain.scale.x -= 0.05;
        }
        if (rl9SizeLeft1.scale.x > 0) {
          rl9SizeLeft1.scale.x -= 0.1;
          rl9SizeLeft2.scale.x -= 0.1;
        }
      }
    },


    // 开车灯
    openLight() {
      this.isOpenLight = !this.isOpenLight
      this.changeModel(this.isOpenLight ? 'kaideng' : 'guandeng')
      this.gio('btnrExhOvalLampCk', this.isOpenLight ? '车灯开' : '车灯关')
      newFontre.toggleCarLight(this.isOpenLight)
    },
    // 尺寸变化
    resize() {
      // location.reload()
      const width = document.documentElement.clientWidth
      const height = document.documentElement.clientHeight
      // console.log('resize', width, height)
      newFontre.resize(width, height)

      // newFontre.scene.getObjectByName('mirror').dispose()

      if (isLandspace()) {
        // 竖屏
        newFontre.camera.position.set(-1783, 137, 384) //(-1886, 191, 906)
      } else {
        //  横屏
        newFontre.camera.position.set(-1783, 137, 384) //(-1886, 191, 906)
      }
    },
    // 改变外观颜色
    changeExColor(color) {
      let _str = color
      for (const val of this.exColors) {
        if (val.color === color) {
          this.gio(val.action, val.name)
          break
        }
      }
      newFontre.changeExteriorColor(_str)
      this.innerPackPool.color = color
      this.currentExColor = color
      // this.specialColor()

    },
    // 改变内饰颜色
    async changeInColor(code) {
      // console.log(this.currentBaseLine + this.innerPackPool.chair + code)
      for (const val of this.chairList) {
        if (val.color === this.innerPackPool.chair) {
          this.gio(val.action, val.name)
          break
        }
      }
      const _night = this.isNight ? 'night_' : ''
      newFontre.changeInteriorColor(_night + this.innerPackPool.chair + code)
    },
    // 特殊颜色逻辑
    specialColor() {
      if (this.currentExColor === 'sliver_black' || this.currentExColor === 'blue_black') {
        this.changeModel('heicheding')
      } else {
        this.changeModel('cheqiding')
      }
    },
    // 切换基础配置线
    changeConfigLine(item) {
      this.currentBaseLine = item
      this.showConfigLine = false
      this.currentHub = item.hub
      this.innerPackPool.trim = item.innerCode

      for (const val of item.codes) {
        console.log(val)
        this.changeModel(val)
      }
      // this.specialColor()

      // if (this.currentBaseLine.baseLine === 'line1') {
      //   this.hubList[0].show = false
      //   this.hubList[1].show = true
      // } else {
      //   this.hubList[0].show = true
      //   this.hubList[1].show = false
      // }

      // if(this.currentBaseLine.baseLine === 'line2'){
      //   this.chairList[0].show = true
      //   this.chairList[1].show = false
      //   this.changeChair(this.chairList[0])
      // } else {
      //   this.chairList[0].show = false
      //   this.chairList[1].show = true
      //   this.changeChair(this.chairList[1])
      // }


    },
    // 切换单组模型
    changeModel(code) {
      newFontre.updateModel(code)
    },
    // 切换轮毂
    changeHub(item) {
      this.currentHub = item.code
      this.changeModel(item.code)
      this.gio('btnrExhOvalHubSlcCk', item.name)
    },
    // 切换座椅联动逻辑
    changeChair(item) {
      // console.log(item.color)
      this.innerPackPool.chair = item.color
      this.currentInColor = item.color
      if (this.currentView === 'in') {
        this.changeInColor(this.currentInnerView)
      }
    },
    // 切换饰条联动逻辑
    changeTrim(item) {
      newFontre.updateModel(item.code)
      this.innerPackPool.trim = item.innerCode
    },
    // 切换内饰顶棚联动逻辑
    changeRoof(item) {
      newFontre.updateModel(item.code)
      this.currentInnerBase = item.innerCode
    },
    // 切换场景
    changeScene(item) {
      this.currentScene = item.code
      newFontre.updateModel(item.code)
      this.changeExColor(this.currentExColor)
      this.changeHdr(this.envList[item.hdr])
    },
    // 切换Hdr
    changeHdr(item) {
      // console.log(newFontre.assetsPath.getTextureDir + item.code +'.hdr')
      newFontre.updateEnvironment(newFontre.assetsPath.getTextureDir + item.code + '.hdr')
    },
    // 一键启动
    async toSport() {
      /**
       * settimeout 是因为 clickmesh 是异步函数, 会影响内部的状态,
       * 导致无法正确关门
       * 后期会优化为同步函数, 来避免添加这个延时函数
       */
      const oAudio2 = document.getElementById("qidongSound");
      const oAudio = document.getElementById("xingshiSound");

      setTimeout(() => {
        const sceneMesh = newFontre.scene.getObjectByName("Scene_RootNode_Rectangle10")
        if (sceneMesh) {
          sceneMesh.visible = !this.isSport
        }
        newFontre.playWheel('lungu_zhuan', this.isSport, 1)
        // 隐藏/显示场景模型
        newFontre.scene.getObjectByName('floor.jpg').visible = this.isSport
        newFontre.scene.fog = this.isSport ? new newFontre.THREE.Fog('#757b87', 2300, 2800) : new newFontre.THREE.Fog('#757b87', 6000, 6001)
      }, 60)

      if (!this.isSport) {
        this.stopAutoRotate()
        if (this.currentView === 'hub') {
          this._leaveHubAnimation()
        }

        // 播放音效

        if (this.isPlayMusic) {
          this.playMusic()
        }

        oAudio2.play();

        oAudio.play();
        oAudio.onended = function () {//播放完毕，重新循环播放
          oAudio.load();
          oAudio.play();
        }


      } else {

        oAudio.pause();
        if (!this.isPlayMusic) {
          this.playMusic()
        }
        if (this.currentView === 'hub') {
          this._nextHubAnimation()
          setTimeout(() => {
            this.changeModel("changkuangao_chicun_off")
            this.changeModel("HideActionHotSpot")
          }, 10)
        } else {
          this.startAutoRotate()
        }
      }
      this.isSport = !this.isSport
      // 关闭所有门
      // const doorState = newFontre._doorState
      // // console.log(doorState)
      // for (const k in doorState) {
      //   if (doorState[k]) {
      //     // newFontre.clickMesh(k)
      //     if (k === '00_trunk_tip') {
      //       newFontre.keyFrame.play('trunk_off', false, 1, k)
      //     }
      //     if (k === '00_lf_door_tip') {
      //       newFontre.keyFrame.play('off_lf_door', false, 1, k)
      //     }
      //     if (k === '00_lr_door_tip') {
      //       newFontre.keyFrame.play('off_lr_door', false, 1, k)
      //     }
      //     if (k === '00_rf_door_tip') {
      //       newFontre.keyFrame.play('off_rf_door', false, 1, k)
      //     }
      //     if (k === '00_rr_door_tip') {
      //       newFontre.keyFrame.play('off_rr_door', false, 1, k)
      //     }
      //   }
      // }

      const visibleHot = !this.isSport ? 'showActionHotSpot' : 'HideActionHotSpot'
      const visibleHot2 = !this.isSport ? 'changkuangao_chicun_open' : 'changkuangao_chicun_off'
      const visibleHot3 = !this.isSport ? 'yijianqidong_huanyuan' : 'yijianqidong'
      newFontre.updateModel(visibleHot)
      newFontre.updateModel(visibleHot2)
      newFontre.updateModel(visibleHot3)
    },
    // 全屏回调
    _toggleFullscreenCallback(item) {
      // success
      if (item.code === 'open') {
        if (!this.isInitGL) {
          this.isLoading = true
          this.initGL()
          this.isInitGL = true
        } else {
          newFontre.showExterior(carCode)
        }
        this.fullScreenStatus = 'close'

        setTimeout(() => {
          newFontre.resize(document.body.clientWidth, document.body.clientHeight)
        }, 300)
      }
      // 退出全屏
      if (item.code === 'close') {
        webViewJavascriptBridge.callHandler(
          "close",
          {
            params: {}//`outSideColorCode=${this.currentExColor}`,
          },
          (err, data) => {
            if (err) {
              console.error(err)
              return
            }
          }
        )
      }
      this.currentView = 'out'
    },
    // 分享
    share() {
      this.gio('btnrExhOvalShareCk', '分享')
      if (application === 'Android' || application === 'iOS') {
        window.jumpToNativePage("/3rdBizCommon/showSharePanoramicCarPage/R", {
          sourceId: sourceId
        })
      }
      else if (application === 'Minp') {
        this.showShareBox = true
        this.gio('pgerExhOvalShareVie', '0')
      }
    },
    closeShowShareBox() {
      this.showShareBox = false
      this.gio('pgerExhOvalShareExit', '1')
    },
    // 联系销售
    sales() {
      this.gio('btnrExhOvalContactSalesCk', '联系销售')
      let _url = {
        appVersion: appVersion,
        userId: userId,
        application: application,
        seriesId: seriesId,
        deviceModel: deviceModel,
        longitude: longitude,
        latitude: latitude,
        IMEI: IMEI,
        ip: ip,
        tencentOpenId: tencentOpenId,
        sourceId: sourceId,
        inviteeId: inviteeId,
        inviteeVisitId: inviteeVisitId,
        inviteeOpenId: inviteeOpenId
      }
      // _url = 'https://sales-apps-qa.rauto.com/sales-lovecar-h5/#/retain?Navigationbar=true&params=' + encodeURIComponent(JSON.stringify(_url))
      _url = 'https://sales-apps.rauto.com/sales-lovecar-h5/#/retain?Navigationbar=true&params=' + encodeURIComponent(JSON.stringify(_url))
      // _url = 'https://sales-apps-pp.rauto.com/sales-lovecar-h5/#/retain?Navigationbar=true&params=' + encodeURIComponent(JSON.stringify(_url))
      if (application === 'Android' || application === 'iOS') {
        // console.log((_url))
        // window.openWebView(_url)
        if (this.isOldVersion()) {
          this.showSalesBox = true
        } else {
          window.jumpToNativePage("/3rdBizCommon/showLeaveInforPage/R", {
            key_ds_url: _url,
            sourceId: sourceId
          })
        }
      } else {
        this.iframeUrl = _url
        this.showIframe = true
      }
    },
    // 隐藏亮点
    closeLightPoint() {
      if (this.nowLightPoint[0].type === 'video') {
        const videoElement = document.getElementById(this.nowLightPoint[0].video)
        videoElement.pause()
        videoElement.src = ""
        videoElement.load()
      }
      this.showLightPoint = false
      let currentTime = Date.now()
      stayTime = currentTime - startTime
      this.gio('pgerExhOvalAnchorPointVie', false, stayTime, '1', this.nowLightPoint[0].title)
    },
    // 埋点
    async gio(actionName, buttonName, stayTime, pageAction, color) {
      // if(!!isPreview){
      //   return
      // }
      // const obj = {
      //   'appVersion': appVersion,
      //   'userId': userId,
      //   'application': application,
      //   'seriesId': seriesId,
      //   'deviceModel': deviceModel,
      //   'longitude': longitude,
      //   'latitude': latitude,
      //   'IMEI': IMEI,
      //   'ip': ip,
      //   'pitName': '360全景',
      //   'pageName': '展厅',
      //   'sendTime': Date.now().toString(),
      //   'tencentOpenId': tencentOpenId,
      //   'tencentUnionId': tencentUnionId,
      //   'inviteeId': inviteeId,
      //   'sourceId': sourceId,
      //   'inviteeVisitId': inviteeVisitId,
      //   'inviteeOpenId': inviteeOpenId
      // }
      // if(buttonName){
      //   if(actionName === 'pgerExhOvalShareVie' || actionName === 'pgerExhOvalShareExit' ){
      //     obj.pitAction = buttonName
      //     if(actionName === 'pgerExhOvalShareExit'){
      //       let currentTime = Date.now()
      //       stayTime = currentTime - startTime
      //       obj.stayTime = stayTime
      //       startTime = Date.now()
      //     }
      //   } else {
      //     obj.buttonName = buttonName
      //   }
      // } else {
      //   if( actionName === 'pgerExhOvalOnVie' ){
      //     obj.pitAction = '0'
      //   } else if(actionName === 'pgerExhOvalPageLoadDurationVie'){
      //     obj.PageLoadDuration = stayTime + ''
      //     delete obj.pitName
      //     startTime = Date.now()
      //   } else if(actionName === 'pgerExhOvalAnchorPointVie' || actionName === 'pgerExhOvalHubSlcVie' ){
      //     obj.pitName = color
      //     obj.pageAction = pageAction
      //     obj.stayTime = stayTime
      //     startTime = Date.now()
      //   } else {
      //     obj.color = color
      //     obj.pageAction = pageAction
      //     obj.stayTime = stayTime
      //     startTime = Date.now()
      //   }
      // }
      // gio('track', actionName, obj);
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resize, false)
  },
  computed: {
    changeData() {
      const { currentExColor, currentInColor, currentView, currentHub } = this
      return {
        currentExColor,
        currentInColor,
        currentHub,
        currentView
      }
    }
  },
  watch: {
    fullScreenStatus(value) {
      this.setPosition(value)
    },
    async changeData(newVal, oldVal) {
      // console.log(newVal,1231231312313)
      // console.log(oldVal,1231231312313)
      let currentTime = Date.now()
      stayTime = currentTime - startTime
      // 切换了内外饰
      if (newVal.currentView !== oldVal.currentView) {
        // 从内饰切换到外饰
        if (newVal.currentView === 'in') {
          for (const val of this.exColors) {
            if (val.color === oldVal.currentExColor) {
              await this.gio('pgerExhOvalExternalColorChoiceStayVie', false, stayTime, '1', val.name)
            }
          }
          // for(const val of this.hubList){
          //   if(val.code === oldVal.currentHub){
          //     await this.gio('pgerExhOvalHubSlcVie',false, stayTime, '1', val.name)
          //   }
          // }
          for (const val of this.chairList) {
            if (val.color === newVal.currentInColor) {
              await this.gio('pgerExhOvalInternalColorChoiceStayVie', false, '', '0', val.name)
            }
          }
        }
        // 从外饰切换到内饰
        if (newVal.currentView === 'out' || newVal.currentView === 'hub') {
          for (const val of this.exColors) {
            if (val.color === newVal.currentExColor) {
              await this.gio('pgerExhOvalExternalColorChoiceStayVie', false, '', '0', val.name)
            }
          }
          // for(const val of this.hubList){
          //   if(val.code === newVal.currentHub){
          //     await this.gio('pgerExhOvalHubSlcVie',false, '', '0', val.name)
          //   }
          // }
          for (const val of this.chairList) {
            if (val.color === oldVal.currentInColor) {
              await this.gio('pgerExhOvalInternalColorChoiceStayVie', false, stayTime, '1', val.name)
            }
          }
        }
      }
      // 切换了车漆
      else if (newVal.currentExColor !== oldVal.currentExColor) {
        for (const val of this.exColors) {
          if (val.color === newVal.currentExColor) {
            await this.gio('pgerExhOvalExternalColorChoiceStayVie', false, '', '0', val.name)
          }
          if (val.color === oldVal.currentExColor) {
            await this.gio('pgerExhOvalExternalColorChoiceStayVie', false, stayTime, '1', val.name)
          }
        }
      }
      // 切换了内饰
      else if (newVal.currentInColor !== oldVal.currentInColor) {
        for (const val of this.chairList) {
          if (val.color === newVal.currentInColor) {
            await this.gio('pgerExhOvalInternalColorChoiceStayVie', false, '', '0', val.name)
          }
          if (val.color === oldVal.currentInColor) {
            await this.gio('pgerExhOvalInternalColorChoiceStayVie', false, stayTime, '1', val.name)
          }
        }
      }
      // 切换了轮毂
      else if (newVal.currentHub !== oldVal.currentHub) {
        for (const val of this.hubList) {
          if (val.code === newVal.currentHub) {
            await this.gio('pgerExhOvalHubSlcVie', false, '', '0', val.name)
          }
          if (val.code === oldVal.currentHub) {
            await this.gio('pgerExhOvalHubSlcVie', false, stayTime, '1', val.name)
          }
        }
      }
    }
  }
}
</script>
<style>
.swiper-pagination-bullet-active {
  background-color: #dd153c !important;
  width: 25px;
  border-radius: 8px;
}

body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
  overflow: hidden;
}
</style>
<style scoped lang='scss'>
*::-webkit-media-controls-panel {
  display: none !important;
  -webkit-appearance: none;
}

*::--webkit-media-controls-play-button {
  display: none !important;
  -webkit-appearance: none;
}


*::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes qtan {
  0% {
    transform: scale(0.95, 1.05);
  }

  50% {
    transform: scale(1.05, 0.95);
  }

  100% {
    transform: scale(0.95, 1.05);
  }
}

iframe {
  position: fixed;
  z-index: 999;
}

.close-btn {
  position: fixed;
  top: 3px;
  right: 20px;
  font-weight: bold;
  font-size: 40px;
  color: #4c4c4c;
  z-index: 1000;
  cursor: pointer;
}

.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 1s ease;
}

#loading {
  background-color: #ffffff;

  #loading-cnt {
    background-image: url("./assets/image/logo2.png");
    width: 917px;
    height: 193px;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    top: calc(35% + 100px);
    left: 50%;
    transform: translate(-50%, -50%);

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      background-image: url("./assets/image/logo.png");
      width: 1%;
      height: 193px;
      max-width: 100%;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .word {
    position: absolute;
    top: calc(35% + 180px);
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .in-train {
    //display: none;
    position: absolute;
    bottom: calc(20% - 120px);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
  }

  .range-slider {
    height: 6px;
    width: 100%;
    font-size: 0;
    border-radius: 3px;
  }

  .range {
    width: 72%;
    height: 6px;
    border-radius: 3px;
  }

  .range-per {
    padding-left: 72%;
    margin: 6px 0 0 0;
    font-size: 12px;
    color: #999;
  }

  .in-train .number {
    color: #253f59;
  }

  .in-train .range-slider {
    background-color: rgba(100, 125, 150, 1);
  }

  .in-train .range {
    width: 0;
    background-color: rgba(37, 63, 89, 1);
  }

  .in-train .range-per {
    padding-left: 0;
  }

  .out-train .number {
    color: #f44d62;
  }

  .out-train .range {
    width: 34.2%;
    /* 进度条进度 */
    background-color: #f44d62;
  }

  .out-train .range-per {
    padding-left: 34.2%;
    /* 利用百分比内边距，制造文字跟随进度条进度的视觉效果 */
  }

  .module-content {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    top: calc(35% + 270px);
  }
}

.header {
  position: relative;
  display: flex;
  align-items: baseline;
  z-index: 10;

  div {
    font-size: 16px;
    color: #999999;
    padding: 8px 16px;
    margin-left: 30px;

    &.active {
      color: #000;
      font-weight: bolder;
      border-bottom: 2px solid;
    }
  }
}

.special-text {
  position: fixed;
  bottom: 10px;
  font-size: 12px;
  color: white;
  right: 10px;
}

.light-point-bg,
.iframe-bg {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(10px);
}

.light-point {
  position: fixed;
  width: 350px;
  height: auto;
  left: 50%;
  top: 50%;
  margin-left: -175px;
  margin-top: -160px;
  background-color: white;
  z-index: 100;
  color: #253e59;
  transform: scale(1.23);
  transition: all 1s ease;

  .item-box {
    display: block;

    .pic-box {
      width: 350px;
      // height: 250px;
      // background-color: #000000;
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: center center;

      img {
        width: 100%;
        height: auto;
      }
    }

    .video-box {
      width: 350px;
      height: 200px;
      background-color: #000000;

      video {
        width: 350px;
        height: 200px;
      }
    }

    .text-box {
      width: 350px;
      height: 100px;
      background: #fff;
      box-sizing: border-box;
      padding: 5px 20px;
      text-align: center;

      .title {
        font-size: 18px;
        font-weight: bolder;
        line-height: 30px;
      }

      .text {
        line-height: 20px;
        font-size: 12px;
      }
    }
  }

  .swiper-button-prev {
    //display: none;
    z-index: 999;
    color: #fff;
    font-size: 20px;
  }

  .swiper-button-next {
    //display: none;
    z-index: 999;
    color: #fff;
    font-size: 20px;
    position: fixed;
  }

  .light-point-close-btn {
    position: absolute;
    bottom: -50px;
    left: 50%;
    font-weight: bolder;
    font-size: 40px;
    color: white;
    z-index: 1000;
    cursor: pointer;
    margin-left: -11px;
    opacity: 0.5;
  }

  .light-point-tab {
    position: absolute;
    top: -45px;
    left: 50%;
    font-weight: bolder;
    font-size: 40px;
    color: white;
    z-index: 1000;
    cursor: pointer;
    width: 350px;
    height: 40px;
    margin-left: -175px;
    display: flex;

    .tab-item {
      background-image: url("./assets/image/light_black.png");
      background-size: 100% 100%;
      width: 33.3%;
      font-size: 12px;
      height: 100%;
      text-align: center;
      line-height: 18px;

      &.fix {
        line-height: 40px;
      }

      &.active {
        background-image: url("./assets/image/light_red.png");
      }
    }
  }
}

.top-panel-line {
  position: fixed;
  top: 110px;
  left: 50%;
  right: 0;
  width: 300px;
  margin-left: -150px;
  transition: 0.3s linear;
  font-size: 20px;
  text-align: center;
  color: white;
  cursor: pointer;
  line-height: 45px;

  &.hide {
    top: -360px
  }

  .arrow {
    display: inline-block;
    font-size: 12px;
    transform: scaleY(0.5) translateY(-5px);
  }

  .line-list {
    background-image: url("./assets/image/line_bg.png");
    background-size: auto 100%;
    border-radius: 5px;
    background-color: rgba(66, 66, 66, 0.75);

    .item:hover {
      background-image: url("./assets/image/line_bg2.png");
      background-size: auto 100%;
      border-radius: 5px;
    }
  }
}

.top-panel {
  position: fixed;
  top: 40px;
  left: 50%;
  right: 0;
  width: 300px;
  margin-left: -150px;
  transition: 0.3s linear;
  font-size: 20px;

  &.hide {
    top: -260px
  }

  .tab-box {
    display: flex;
    color: black;

    .tab-item {
      cursor: pointer;
      width: 50%;
      margin: 0;
      text-align: center;
      line-height: 45px;
      border-bottom: 2px black solid;
      text-shadow: #aaa 1px 0 3px, #aaa 0 1px 3px, #aaa -1px 0 3px, #aaa 0 -1px 3px;

      &:first-child {
        &.active {
          font-weight: bolder;
          color: #ffffff;
          border-bottom: 3px white solid;
        }
      }

      &:last-child {
        border-right: 0;

        &.active {
          color: #ffffff;
          font-weight: bolder;
          border-bottom: 3px white solid;
        }
      }
    }
  }
}

.bottom-panel {
  position: fixed;
  bottom: -20px;
  left: 50%;
  right: 0;
  width: 600px;
  margin-left: -300px;
  transition: 0.3s linear;
  transform: scale(0.88);

  &.hide {
    bottom: -160px
  }

  .hide-button {
    cursor: pointer;
    position: absolute;
    top: -5px;
    background-image: url("./assets/image/hide_btn.png");
    background-size: cover;
    height: 25px;
    width: 25px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .show-button {
    cursor: pointer;
    position: absolute;
    top: -5px;
    background-image: url("./assets/image/show_btn.png");
    background-size: cover;
    height: 25px;
    width: 25px;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .tab-box {
    display: flex;
    background: url("./assets/image/ctrl_bg2.png");
    background-size: cover;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 60px;
    bottom: 0;
    width: 480px;
    color: white;

    .tab-item {
      cursor: pointer;
      width: 50%;
      margin: 0 0 -1px 0;
      text-align: center;
      line-height: 65px;
      border-bottom: 1px transparent solid;

      &:first-child {
        padding-left: 90px;

        &.active {
          font-weight: bolder;
          background: url("./assets/image/ctrl_bg2_1.png");
          background-size: cover;
        }
      }

      &:last-child {
        padding-right: 90px;
        border-right: 0;

        &.active {
          color: #ffffff;
          font-weight: bolder;
          background: url("./assets/image/ctrl_bg2_2.png");
          background-size: cover;
        }
      }
    }
  }

  .content-box {
    background-image: url("./assets/image/ctrl_bg1.png");
    background-size: cover;
    width: 100%;
    height: 190px;
    align-items: center;
    box-sizing: border-box;
    padding: 0 10%;
    color: white;

    .item-box {
      width: 80%;
      max-width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 0 auto;
      padding-top: 20px;

      //padding-right: 5px;
      &.only-one {
        justify-content: center;
      }
    }

    .color-item {
      width: 36px;
      height: 36px;
      margin: 10px 0px 30px 0px;
      cursor: pointer;
      border: 3px rgba(222, 222, 222, 0.5) solid;
      border-radius: 50% 50%;
      color: rgba(255, 255, 255, 0.75);
      transition: all 0.3s ease;

      &:hover {
        animation-name: qtan;
        animation-duration: 1s;
      }

      &.active {
        background-color: transparent;
        border-radius: 50% 50%;
        //border: 3px rgba(195,13,35,0.35) solid;
        border: 3px white solid;

        .color-name {
          color: white;
          font-weight: bold;
        }
      }

      .color-img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        //transform: rotate(160deg) ;
      }

      .color-name {
        margin-top: 10px;
        font-size: 12px;
        text-align: center;
        width: 46px;
        margin-left: -6px;
      }
    }

    &.inner-style {
      padding: 0 28%;
    }

    &.hub-style {
      padding: 0 44.1%;

      .item-box {
        width: 60%;
      }

      .color-item {
        .color-name {
          margin-top: 10px;
          font-size: 14px;
          text-align: center;
          width: 125px;
          margin-left: -44px;
        }
      }
    }
  }

  .bottom-text {
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    margin: 0 auto;
    width: 100%;
    height: 60px;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 0 10% 10px 10%;
    font-size: 10px;
    box-sizing: border-box;
    color: #666;
    font-weight: normal;
  }
}

.sales-box {
  position: fixed;
  z-index: 100;
  width: 200px;
  height: 270px;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(40, 55, 65, 0.8);
  border-radius: 20px;

  .close {
    color: #ffffff;
    font-size: 40px;
    text-align: right;
    margin-right: 10px;
  }

  img {
    width: 150px;
    height: 150px;
    padding: 0 25px 15px 25px;
  }

  .text {
    text-align: center;
    color: #ffffff;
  }
}

.share-box {
  .shareMask-content-miniScreen1 {
    position: absolute;
    width: 120px;
    height: 90px;
    top: 30px;
    right: 70px;
    z-index: 999;
  }

  .text {
    position: absolute;
    width: 220px;
    height: 60px;
    color: #fff;
    top: 130px;
    right: 100px;
    text-align: center;
    line-height: 30px;
    z-index: 999;

    .share-btn {
      display: inline;
      height: 15px;
      width: 30px;
      margin-left: 5px;
      vertical-align: middle;
    }
  }
}

// 内饰切换开关
.switch-btn {
  width: 36px;
  height: 84px;
  position: absolute;
  bottom: 250px;
  right: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 20px;
  cursor: pointer;
  background-image: url("../public/imgs/bg03.png");
  background-size: cover;
  text-align: center;
  font-size: 13px;
  color: #ffffff;

  &.night {
    right: auto;
    left: 10px;
  }

  .baseBtn {
    width: 32px;
    height: 32px;
    background-image: url("../public/imgs/bg04.png");
    background-size: cover;
  }

  // 前排
  .frontText {
    margin-top: 10px;
  }

  .frontRowBtn {
    transform: translate(1.5px, 4.5px);
  }

  // 后排
  .backText {
    transform: translateY(10px);
  }

  .backRowBtn {
    transform: translate(1.5px, 2px);
  }
}

// 顶部按钮
.top-btn {
  position: fixed;
  top: 100px;
  right: 18px;
  transition: 1s linear;

  //background-color: rgba(255,255,255,0.4);
  //border-radius: 10px;
  //padding: 5px 5px 10px 5px;
  .sp {
    .pic {
      -webkit-transform: rotate(360deg);
      animation: rotation 3s linear infinite;
      -moz-animation: rotation 3s linear infinite;
      -webkit-animation: rotation 3s linear infinite;
      -o-animation: rotation 3s linear infinite;
    }
  }

  .item {
    width: 60px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;

    .pic {
      width: 44px;
      height: 44px;
      margin: 6px 8px;
    }

    .first {
      width: 32px;
      height: 32px;
      margin: 6px 14px;
    }

    .last {
      width: 26px;
      height: 26px;
      margin: 6px 18px;
    }

    .text {
      font-size: 12px;
      color: white;
      //text-shadow: #aaa 1px 0 3px, #aaa 0 1px 3px, #aaa -1px 0 3px, #aaa 0 -1px 3px;
    }

    .white {
      color: #ffffff;
      text-shadow: none;
    }
  }
}

.left-btn {
  transition: 1s linear;
  position: fixed;
  top: 100px;
  left: 18px;

  //background-color: rgba(255,255,255,0.4);
  //border-radius: 10px;
  //padding: 5px 5px 10px 5px;
  .item {
    width: 60px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;

    .pic {
      width: 44px;
      height: 44px;
      margin: 6px 8px;
    }

    .text {
      font-size: 12px;
      color: white;
      //text-shadow: #aaa 1px 0 3px, #aaa 0 1px 3px, #aaa -1px 0 3px, #aaa 0 -1px 3px;
    }

    .white {
      color: #ffffff;
      text-shadow: none;
    }
  }
}

.footer {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: black;
  text-align: center;

  //padding-left: 35%;
  .box {
    margin: 0 auto;
    width: 660px;
  }

  .item {
    cursor: pointer;
    width: 100px;
    float: left;
    margin: 6px 30px;

    img {
      width: 48px;
    }

    div {
      color: white;
      line-height: 48px;
      height: 48px;
      float: right;
    }
  }
}

.drive-btn {
  position: fixed;
  bottom: 100px;
  left: -20px;
  opacity: 0.8;
  cursor: pointer;
  z-index: 80;
}

@media (min-height: 800px) {
  .light-point {
    transform: scale(1.8);
  }
}

@media (min-height: 1000px) {
  .light-point {
    transform: scale(2.2);
  }
}

@media (max-height: 650px) {
  .light-point {
    transform: scale(1.4);
  }

  .special-text {
    transform: scale(0.8);
    transform-origin: 0 0;
    left: 5px;
    bottom: 5px;
  }
}

@media (max-height: 490px) {
  #loading {
    background-color: #ffffff;

    #loading-cnt {
      background-image: url("./assets/image/mlogo2.png");
      width: 366px;
      height: 78px;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      top: calc(15% + 100px);
      left: 50%;
      transform: translate(-50%, -50%);

      .cover {
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("./assets/image/mlogo.png");
        width: 150px;
        height: 78px;
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .word {
      position: absolute;
      top: calc(15% + 120px);
      left: 50%;
      transform: translate(-50%, -50%) scale(0.8);
      transform-origin: 50% 0;
    }

    .in-train {
      bottom: calc(25% - 200px);
    }

    .module-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.75);
      width: 100px;
      top: calc(15% + 200px);
    }
  }

  .left-btn {
    top: 20px;
    transform: scale(0.9);
    transform-origin: 50% 0;
  }

  .top-btn {
    top: 20px;
    transform: scale(0.9);
    transform-origin: 50% 0;
  }

  .drive-btn {
    transform: scale(0.7);
    left: -50px;
    bottom: 30px;
    opacity: 0.9;
  }

  .bottom-panel {
    transform: scale(0.6);
    bottom: -45px;

    &.hide {
      bottom: -135px;
    }
  }

  .top-panel {
    top: 10px;
    transform: scale(0.8);
  }

  .top-panel-line {
    top: 60px;
    transform: scale(0.8);
    transform-origin: 50% 0;
    z-index: 90;
  }

  .light-point {
    transform: scale(0.75);
  }
}

@media (max-width: 650px) {
  #loading {
    background-color: #ffffff;

    #loading-cnt {
      background-image: url("./assets/image/mlogo2.png");
      width: 366px;
      height: 78px;
      background-size: cover;
      background-repeat: no-repeat;
      position: relative;
      top: calc(25% + 120px);
      left: 50%;
      transform: translate(-50%, -50%);

      .cover {
        position: absolute;
        top: 0;
        left: 0;
        background-image: url("./assets/image/mlogo.png");
        width: 150px;
        height: 78px;
        background-size: cover;
        background-repeat: no-repeat;
      }
    }

    .word {
      position: absolute;
      top: calc(25% + 120px);
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .module-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.75);
      width: 100px;
      top: calc(25% + 220px);
    }
  }

  .light-point {
    transform: scale(1);
  }

  .special-text {
    transform: scale(0.7);
    transform-origin: 0 0;
    left: 50%;
    margin-left: -140px;
    bottom: 8px;
    opacity: 0.9;
    width: 420px;
  }

  .bottom-panel {
    position: fixed;
    transform: scale(0.9);
    bottom: 5px;
    margin-bottom: 33px;

    .content-box {
      .item-box {
        width: 88vw;
        max-width: 88%;

        .color-item {}
      }

      &.inner-style {
        .item-box {
          width: 70vw;
        }
      }

      &.hub-style {
        .item-box {
          //width: 17%;
        }
      }
    }

  }

  .top-panel {
    top: 20px;
    left: 50%;
    right: 0;
    width: 200px;
    margin-left: -100px;
    transition: 0.3s linear;
    font-size: 16px;

    .tab-box {
      .tab-item {
        line-height: 35px;
      }
    }
  }

  .top-btn {
    top: 75px;
    right: 8px;
  }

  .left-btn {
    top: 75px;
    left: 8px;
  }

  .drive-btn {
    transform: scale(0.7);
    left: -50px;
    bottom: 170px;
    opacity: 0.9;
  }

  .top-panel-line {
    position: fixed;
    top: 60px;
    left: 50%;
    right: 0;
    width: 200px;
    margin-left: -100px;
    transition: 0.3s linear;
    font-size: 14px;
    text-align: center;
    color: white;
    cursor: pointer;
    line-height: 35px;
  }
}

@media (max-width: 380px) {
  .top-btn {
    transform: scale(0.82);
    transform-origin: 100% 0;
    top: 65px;
    right: 3px;
  }

  .left-btn {
    transform: scale(0.82);
    transform-origin: 0 0;
    top: 65px;
    left: 3px;
  }

  .bottom-panel {
    position: fixed;
    transform: scale(0.82);
    bottom: 1px;
  }
}
</style>

